import React, { Component, useEffect } from 'react';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Header from '@appblocks/frontend/client/Header';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import { confirm as confirmDialog } from 'react-bootstrap-confirmation';
import { useSelector } from 'react-redux';

import { axiosInstance } from '@appblocks/frontend/client/utils';

const store = require('@appblocks/frontend/redux/store').default;

const PageWorkspaceSettings = (props) => {
    const [name, setName] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [newName, setNewName] = React.useState('');
    const [showSetName, setShowSetName] = React.useState(false);
    const [users, setUsers] = React.useState([]);
    const [newEmail, setNewEmail] = React.useState('');
    const [showAddUser, setShowAddUser] = React.useState(false);
    const workspaces = useSelector(state => state.workspaces);


    const { user } = store.getState().user;
    if (!user) {
        props.history.replace({
            pathname: '/',
        });
    }

    const loadWorkspace = async () => {
        const workspaceId = workspaces.currentWorkspace;
        setLoading(true);
        axiosInstance.get(`${process.env.API_URL}/api/workspaces/${workspaceId}`).then((response) => {
            setLoading(false);
            setUsers(response.data.users);
            setName(response.data.name);
        });
    };

    const startSetName = () => {
        setNewName(name);
        setShowSetName(true);
    };

    const startAddUser = () => {
        setShowAddUser(true);
        setNewEmail('');
    };

    const addUser = (e) => {
        e.preventDefault();
        const workspaceId = workspaces.currentWorkspace;
        axiosInstance.post(`${process.env.API_URL}/api/workspaces/${workspaceId}/users`, {
            email: newEmail,
        }).then((response) => {
            setShowAddUser(false);
            loadWorkspace();
        })
            .catch((e) => {
                alert('Error adding user');
            });
    };

    const removeUser = async (user) => {
        if (!await confirmDialog(`Remove ${user.email} from workspace?`)) {
            return;
        }
        const workspaceId = workspaces.currentWorkspace;
        setLoading(true);
        axiosInstance.delete(`${process.env.API_URL}/api/workspaces/${workspaceId}/users/${user.user}`, {
            email: newEmail,
        }).then((response) => {
            loadWorkspace();
        });
    };

    const updateWorkspace = (e) => {
        e.preventDefault();
        const workspaceId = workspaces.currentWorkspace;
        axiosInstance.put(`${process.env.API_URL}/api/workspaces/${workspaceId}`, {
            name: newName,
        }).then((response) => {
            setShowSetName(false);
            loadWorkspace();
            store.dispatch({
                type: 'workspaces/getWorkspaces',
            });
        });
    };

    useEffect(() => {
        loadWorkspace();
    }, [workspaces.currentWorkspace]);

    return (
        <>
            {
                loading ? (
                    <Spinner animation="border" />
                ) : (
                    <form className="col-12 mt-2">
                        <h3>Workspace Settings</h3>
                        <div className="col-md-6">
                            <h5>
                                {name}
                                <Button variant="link" onClick={startSetName}>
                                    Edit
                                </Button>
                            </h5>

                        </div>
                        {/* <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="lastName">Last Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="lastName"
                            placeholder="Last Name"
                            value={this.state.newSettings.lastName}
                            onChange={e => this.updateField('lastName', e.target.value)}
                        />
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label" htmlFor="email">Email</label>
                        <input
                            type="text"
                            className="form-control"
                            id="email"
                            placeholder={user.email}
                            value={user.email}
                            disabled
                        />
                    </div>
                    <div className="col-3">
                        <button
                            type="submit"
                            disabled={!this.state.hasChanges}
                            className="form-control btn btn-primary"
                            onClick={this.save}
                        >
                            Save
                        </button>
                    </div> */}
                        <div className="col-md-6">
                            <h5>Members</h5>
                            <Table>
                                <thead className="table-secondary">
                                    <tr>
                                        <th>
                                            Email
                                        </th>
                                        <th>
                                            Role
                                        </th>
                                        <th>
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {user.email}
                                        </td>
                                        <td>
                                            Owner
                                        </td>
                                        <td />
                                    </tr>
                                    {users.map(user => (
                                        <tr key={user.user}>
                                            <td>{user.email}</td>
                                            <td>
                                                Member
                                            </td>
                                            <td
                                                className="table-actions"
                                            >
                                                <Button variant="link" size="sm" onClick={() => removeUser(user)}>
                                                    Remove
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <Button variant="primary" size="sm" onClick={startAddUser}>
                                Add Member
                            </Button>
                        </div>
                    </form>
                )
            }
            <Modal
                show={showAddUser}
                onHide={() => setShowAddUser(false)}
            >
                <form onSubmit={addUser}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span>Add User to Workspace</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="User Email"
                            value={newEmail}
                            onChange={e => setNewEmail(e.target.value)}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit" variant="primary">
                            Add
                        </Button>
                        <Button variant="secondary" onClick={() => setShowAddUser(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal
                show={showSetName}
                onHide={() => setShowSetName(false)}
            >
                <form onSubmit={updateWorkspace}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span>Edit Workspace Name</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Workspace Name"
                            value={newName}
                            onChange={e => setNewName(e.target.value)}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit" variant="primary">
                            Save
                        </Button>
                        <Button variant="secondary" onClick={() => setShowSetName(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
};

export default PageWorkspaceSettings;
